// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/aktion-herzensretter/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const aktionHerzensretterDE: PageEntry = {
  id: "post.aktion-herzensretter",
  locale: "de",
  slug: "aktion-herzensretter",
  seo: {
    title: "Aktion \"Herzensretter\" | Dietz GmbH",
    description: "Aktion \"Herzensretter\"",
  },
  type: "post",
  h1: "Aktion \"Herzensretter\"",
  blocks: [
    { kind: "heading", level: 2, text: "Aktion „Herzensretter“" },
    { kind: "paragraph", text: "DIETZ macht sein Team mit einer Spende von 2.500 Euro an der Aktion „Herzensretter“ des ASB Coburger Land e. V. Herz-sicher. Dafür haben wir am Dienstag von Angelique Kraus (vom ASB) einen funkelnagelneuen Defibrillator für das neue Verwaltungsgebäude überreicht bekommen." }
  ],
};
